import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { EntityType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { ENTITIES } from "../../utils/constants";

export const createEntity = async (data: EntityType) => await post<EntityType, string>(ENTITIES, data);
export const updateEntity = async (data: EntityType) => await put<EntityType, string>(ENTITIES, data);

export const getEntities = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${ENTITIES}?${queryParams.toString()}`;
    return await get<PagedResultsType<EntityType>>(url)
};